import { useMemo } from 'react';
import { hasGlobalTerritoriesApplied } from '@helpers/territories';
import FilterTypes from '../../../../constants/FilterTypes.ts';
import { actionTypes } from '../reducer';

const useFilters = ({
  filters,
  dispatch,
  visitTypesForSelect,
  trackedObjectId,
  timeZonesForSelect,
  hasMultiTimezone
}) => {
  const globalTerritoriesApplied = hasGlobalTerritoriesApplied();
  const onChangeFilter = (fieldName) => (value) => {
    dispatch({ type: actionTypes.FILTER_CHANGED, value, field: fieldName });
  };

  const onToggleFilter = (fieldName) => () => {
    dispatch({ type: actionTypes.FILTER_TOGGLED, field: fieldName });
  };

  const onChangeDateFilter = (fieldName) => (dateFieldName, value) => {
    dispatch({
      type: actionTypes.DATE_RANGE_FILTER_CHANGED,
      field: fieldName,
      dateField: dateFieldName,
      value
    });
  };

  const filtersList = useMemo(() => {
    const list = [
      {
        field: 'technician',
        locale: 'technician',
        type: FilterTypes.GenericMultiSelect,
        active: filters.active.technician,
        value: filters.values.technician || [],
        onChange: onChangeFilter('technician'),
        onToggle: onToggleFilter('technician'),
        disableSorting: true,
        withUnassigned: false,
        allowLetterAvatar: true
      },
      {
        field: 'visitType',
        locale: 'visit_type',
        type: trackedObjectId ? FilterTypes.Hidden : FilterTypes.GenericMultiSelect,
        active: filters.active.visitType,
        value: filters.values.visitType,
        onChange: onChangeFilter('visitType'),
        onToggle: onToggleFilter('visitType'),
        optionsForSelect: visitTypesForSelect.map(({ label, value }) => ({ title: label, value }))
      },
      {
        field: 'building',
        locale: 'building',
        type: trackedObjectId ? FilterTypes.Hidden : FilterTypes.GenericMultiSelect,
        active: filters.active.building,
        value: filters.values.building,
        onChange: onChangeFilter('building'),
        onToggle: onToggleFilter('building')
      },
      {
        field: 'technicianTeam',
        locale: 'technician_team',
        type: FilterTypes.GenericMultiSelect,
        active: filters.active.technicianTeam,
        value: filters.values.technicianTeam,
        onChange: onChangeFilter('technicianTeam'),
        onToggle: onToggleFilter('technicianTeam')
      },
      {
        field: 'date',
        locale: 'date',
        type: 'dateRangePicker',
        active: filters.active.date,
        values: filters.values.date,
        onChange: onChangeDateFilter('date'),
        onToggle: onToggleFilter('date')
      }
    ];

    if (!globalTerritoriesApplied) {
      list.push({
        field: 'territory',
        locale: 'territory',
        type: trackedObjectId ? FilterTypes.Hidden : FilterTypes.GenericMultiSelect,
        active: filters.active.territory,
        value: filters.values.territory,
        withUnassigned: true,
        onChange: onChangeFilter('territory'),
        onToggle: onToggleFilter('territory')
      });
    }

    if (hasMultiTimezone) {
      list.push({
        field: 'timeZone',
        locale: 'time_zone',
        type: FilterTypes.GenericMultiSelect,
        active: filters.active.timeZone,
        value: filters.values.timeZone,
        onChange: onChangeFilter('timeZone'),
        onToggle: onToggleFilter('timeZone'),
        optionsForSelect: timeZonesForSelect.map(({ label, value }) => ({ title: label, value }))
      });
    }

    return list;
  }, [
    filters,
    dispatch,
    visitTypesForSelect,
    globalTerritoriesApplied,
    trackedObjectId,
    timeZonesForSelect,
    hasMultiTimezone
  ]);

  return filtersList;
};

export default useFilters;
